import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useState } from 'react';
export var useOnIntersection = function useOnIntersection(props) {
  var onBottomStuck = props.onBottomStuck,
    onTopStuck = props.onTopStuck;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOnBottomStuck = _useState2[0],
    setIsOnBottomStuck = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isOnTopStuck = _useState4[0],
    setIsOnTopStuck = _useState4[1];
  return {
    isOnBottomStuck: isOnBottomStuck,
    isOnTopStuck: isOnTopStuck,
    onIntersection: useCallback(function (intersectionData) {
      if (intersectionData.isIntersecting) {
        if (intersectionData.isStuckToTop) {
          onTopStuck === null || onTopStuck === void 0 ? void 0 : onTopStuck(true);
          setIsOnTopStuck(true);
        }
        if (intersectionData.isStuckToBottom) {
          onBottomStuck === null || onBottomStuck === void 0 ? void 0 : onBottomStuck(true);
          setIsOnBottomStuck(true);
        }
      } else {
        onBottomStuck === null || onBottomStuck === void 0 ? void 0 : onBottomStuck(false);
        onTopStuck === null || onTopStuck === void 0 ? void 0 : onTopStuck(false);
        setIsOnBottomStuck(false);
        setIsOnTopStuck(false);
      }
    }, [onBottomStuck, onTopStuck])
  };
};